// src/pages/Auth/DiscordCallback.jsx
import React, { useEffect, useState, useContext, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import './LoginPage.css';

const DiscordCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleDiscordLogin } = useContext(AuthContext);
  const [status, setStatus] = useState('processing'); // 'processing', 'error'
  const [errorMsg, setErrorMsg] = useState('');
  const hasProcessed = useRef(false); // Evita doble ejecución en React Strict Mode

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const code = searchParams.get('code');
    if (!code) {
      setStatus('error');
      setErrorMsg('No se recibió el código de autorización de Discord.');
      return;
    }

    const processLogin = async () => {
      try {
        await handleDiscordLogin(code);
        // handleDiscordLogin ya navega a /dashboard si tiene éxito
      } catch (err) {
        console.error('Error in Discord authentication:', err);
        setStatus('error');
        setErrorMsg(err.message || 'Error al autenticar con Discord.');
      }
    };

    processLogin();
  }, [searchParams, handleDiscordLogin]);

  if (status === 'processing') {
    return (
      <div className="login-page">
        <div className="login-background-overlay"></div>
        <div className="login-container" style={{ textAlign: 'center' }}>
          <div className="login-card" style={{ padding: '40px 30px' }}>
            <h2 className="login-title" style={{ marginBottom: 20 }}>Conectando con Discord</h2>
            <div className="modern-spinner" style={{ margin: '20px auto' }}></div>
            <p style={{ color: '#bbb', marginTop: 15 }}>Espera un momento mientras validamos tu sesión...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-background-overlay"></div>
      <div className="login-container">
        <div className="login-card" style={{ textAlign: 'center', padding: '40px 30px' }}>
          <h2 className="login-title" style={{ color: '#ff4444' }}>Error de Autenticación</h2>
          <div style={{ fontSize: '48px', margin: '20px 0', color: '#ff4444' }}>⚠</div>
          <p style={{ color: '#fff', marginBottom: 25, fontSize: '1.05rem' }}>{errorMsg}</p>
          
          <button 
            className="login-button" 
            onClick={() => navigate('/login')}
            style={{ width: '100%', maxWidth: '250px', margin: '0 auto' }}
          >
            <span>Volver al Login</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscordCallback;
